"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountDown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactCountdownCircleTimer = require("react-countdown-circle-timer");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CountDown = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var fontSize = _ref.fontSize,
    Size = _ref.Size,
    StrokeWith = _ref.StrokeWith,
    Colors = _ref.Colors,
    ColorsTime = _ref.ColorsTime,
    onComplete = _ref.onComplete,
    BackgroundColor = _ref.BackgroundColor,
    Duration = _ref.Duration;
  var _useCountdown = (0, _reactCountdownCircleTimer.useCountdown)({
      isPlaying: true,
      duration: Duration,
      colors: Colors,
      colorsTime: ColorsTime,
      size: Size,
      strokeWidth: StrokeWith,
      onComplete: onComplete
    }),
    path = _useCountdown.path,
    pathLength = _useCountdown.pathLength,
    stroke = _useCountdown.stroke,
    strokeDashoffset = _useCountdown.strokeDashoffset,
    remainingTime = _useCountdown.remainingTime,
    elapsedTime = _useCountdown.elapsedTime,
    size = _useCountdown.size,
    strokeWidth = _useCountdown.strokeWidth;
  var svg = function svg() {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: size,
      height: size
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: "gradient",
      x1: "1",
      y1: "0",
      x2: "0",
      y2: "0"
    }, /*#__PURE__*/_react.default.createElement("stop", {
      offset: "5%",
      stopColor: "gold"
    }), /*#__PURE__*/_react.default.createElement("stop", {
      offset: "95%",
      stopColor: "red"
    }))), /*#__PURE__*/_react.default.createElement("path", {
      d: path,
      fill: "none",
      stroke: BackgroundColor,
      strokeWidth: strokeWidth
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: path,
      fill: "none",
      stroke: stroke,
      strokeLinecap: "butt",
      strokeWidth: strokeWidth,
      strokeDasharray: pathLength,
      strokeDashoffset: strokeDashoffset
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "timer",
    "aria-live": "assertive",
    style: {
      position: 'absolute',
      top: size / 2,
      left: size / 2,
      transform: "translate(-50%,-50%)",
      fontSize: "".concat(fontSize)
    }
  }, remainingTime), svg());
});
exports.CountDown = CountDown;
CountDown.PropTypes = {
  onComplete: _propTypes.default.func,
  fontSize: _propTypes.default.string,
  BackgroundColor: _propTypes.default.any,
  Size: _propTypes.default.number,
  Colors: _propTypes.default.array,
  ColorsTime: _propTypes.default.array,
  Duration: _propTypes.default.number
};
CountDown.defaultProps = {
  BackgroundColor: "#d9d9d9",
  onComplete: function onComplete(e) {
    return console.log(e);
  },
  fontSize: "1.3rem",
  Size: 30,
  Duration: 10,
  StrokeWith: 4,
  Colors: ['#ffca2c', '#ffca2c', '#ef0000'],
  ColorsTime: [10, 3, 0]
};